<script setup lang="ts">
import { useRoute } from 'vue-router';

import AdvancedSearchView from '@/views/searches/AdvancedSearchView.vue';
import JobIdSearchView from '@/views/searches/JobIdSearchView.vue';
import PostCodeSearchView from '@/views/searches/PostCodeSearchView.vue';
import SuburbsSearchView from '@/views/searches/SuburbsSearchView.vue';
import * as routeNames from '@/constants/routeNames';

const route = useRoute();
</script>

<template>
  <v-window
    v-model="route.name"
    :class="$style.searchVWindow"
    data-testid="searchVWindow"
    :touch="false"
  >
    <v-window-item :value="routeNames.SEARCH_JOB_ID">
      <JobIdSearchView
        v-if="routeNames.SEARCH_JOB_ID === route.name /* unmounting */"
      />
    </v-window-item>
    <v-window-item :value="routeNames.SEARCH_ADVANCED">
      <AdvancedSearchView
        v-if="routeNames.SEARCH_ADVANCED === route.name /* unmounting */"
      />
    </v-window-item>
    <v-window-item :value="routeNames.SEARCH_POSTCODE">
      <PostCodeSearchView
        v-if="routeNames.SEARCH_POSTCODE === route.name /* unmounting */"
      />
    </v-window-item>
    <v-window-item :value="routeNames.SEARCH_SUBURBS">
      <SuburbsSearchView
        v-if="routeNames.SEARCH_SUBURBS === route.name /* unmounting */"
      />
    </v-window-item>
  </v-window>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.searchVWindow {
}
</style>
